// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"201": "4c414c0baa9e","3571": "bb0d7aea5624","5049": "0de64869a981",}[chunkId] + ".css"
}